import Cookies from 'js-cookie'

var closeEmergencyAlertBtn = null
var emergencyAlertCookie = null

export function initialize() {
  inspectEnvironment()
}

export function inspectEnvironment() {
  closeEmergencyAlertBtn	= document.querySelector('.close-emergency-alert');
  emergencyAlertCookie		= (Cookies.get('closeEmergencyAlert')) ? Cookies.get('closeEmergencyAlert') : 'false';
  if(closeEmergencyAlertBtn) {
	  addListeners()
	  setInitial()	  	
  }
}

export function addListeners() {
  closeEmergencyAlertBtn.addEventListener('click', hideEmergencyAlert, false)
}


export function setInitial() {
  if(emergencyAlertCookie == 'true') {
	  hideEmergencyAlert();
  }
}

export function hideEmergencyAlert() {
	$('.emergency-alert').addClass('hidden');
    Cookies.set('closeEmergencyAlert', 'true', { expires: 1 });
}